import React from "react";

import css from "./ModalStyles.module.css";
import useManageModal from "./hooks/useManageModal";

type Props = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  className?: string;
};

const Modal = ({ children, isOpen, onClose, className }: Props) => {
  const { handleCloseClick, handleContainerClick } = useManageModal({
    onClose,
  });

  return isOpen ? (
    <div className={className}>
      <div className={css.container} onClick={handleContainerClick}>
        {children}
      </div>
      <div className={css.overlay} onClick={handleCloseClick}></div>
    </div>
  ) : null;
};

export default Modal;
